import axios from 'axios';
import toastr from 'toastr';
import {capitalize} from '@utilities/string';

const baseDomain = window.APP.url;
const baseURL = `${baseDomain}/api`;

const instance = axios.create({
    baseURL,
    headers: {

    },
});

instance.interceptors.response.use(
    (response) => {
        return response;
    },

    error => {
        if (error.response.data.errors) {
            for (let [field, errors] of Object.entries(error.response.data.errors)) {
                errors.forEach(function (error) {
                    toastr.error(capitalize(error));
                });
            }
        } else {
            toastr.error(window.APP.generalErrorMessage);
        }

        return Promise.reject(error);
    },
);

export default instance;
